import { IProductUpSale } from "Components/Ecom/Product/UpSale/Models";

export default class UpSaleService {

    static quantityInDifferenceMax = 3;
    static percentageInDifferenceMax = 25;

    public static isUpSale(quantityInDifference: number, percentageInDifference: number) {
        if (quantityInDifference <= 0)
            return false;

        if (quantityInDifference <= this.quantityInDifferenceMax) {
            return true;
        }

        if (percentageInDifference > 0 && percentageInDifference <= this.percentageInDifferenceMax) {
            return true;
        }

        return false;
    }

    

}